import {
  POS_QUICK_LOADING,
  POS_QUICK_LAYOUT,
  POS_QUICK_ERROR,
  POS_QUICK_RESET,
} from "./actionTypes";

const initialState = {
  groups: [], // owner-defined chips, each with .items and .groups (one level deep)
  pinned: [], // tiles shown in every view — currently the general/open item
  openItemId: null, // hidden catalog item every open-price line is booked against
  loading: false,
  loaded: false,
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_QUICK_LOADING:
      return { ...state, loading: true, error: null };

    case POS_QUICK_LAYOUT:
      return {
        ...state,
        groups: action.payload.groups || [],
        pinned: action.payload.pinned || [],
        openItemId: action.payload.open_item_id || null,
        loading: false,
        loaded: true,
        error: null,
      };

    case POS_QUICK_ERROR:
      return { ...state, loading: false, error: action.payload };

    case POS_QUICK_RESET:
      return initialState;

    default:
      return state;
  }
}
